var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "bb-collapsible slider",
      class: { closed: _vm.$root.step < _vm.step },
      style: _vm.element_style,
    },
    [
      _c(
        "h2",
        {
          staticClass: "slider clickable",
          class: { closed: _vm.$root.step <= _vm.step },
          staticStyle: { "max-height": "100px" },
          on: {
            click: function ($event) {
              _vm.$root.step = _vm.step
            },
          },
        },
        [
          _c("span", { staticClass: "step" }, [
            _vm._v("Step " + _vm._s(_vm.step)),
          ]),
          _vm._v(" "),
          _c("span", { domProps: { innerHTML: _vm._s(_vm.label) } }),
        ]
      ),
      _vm._v(" "),
      _c(
        "form",
        {
          ref: "form",
          staticClass: "slider",
          class: { closed: _vm.$root.step > _vm.step },
          style: _vm.element_style,
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.next.apply(null, arguments)
            },
          },
        },
        [
          _vm.label
            ? _c("div", { staticClass: "step-label" }, [
                _vm._v(_vm._s(_vm.step)),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._t("default"),
          _vm._v(" "),
          _c("div", { staticClass: "container" }, [
            _vm.has_next
              ? _c("button", { staticClass: "btn btn-primary btn-next" }, [
                  _vm._v("Next"),
                ])
              : _vm._e(),
          ]),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }